import { ArrowUpward, AutoAwesomeOutlined } from '@mui/icons-material'
import { Box, Card, CardContent, Fab, TextField, Typography } from '@mui/material'
import React from 'react'
import { useMindset } from '../../../../components/mindset-agent/mindset-context'
import { ActionButton } from '../../../../components'
import { ChatAIWhite } from '../../../../components/icons'
import { useTrackHomeEnterpriseEvent } from '../../hooks/useTrackHomeEnterpriseEvent'
import { HOME_SECTION_TYPE } from './home-sections'

export const MCoachPromo = () => {
  const [mCoachQuestion, setMCoachQuestion] = React.useState('')
  const { openMindset, hasBeenOpened } = useMindset()
  const { trackClickEvent } = useTrackHomeEnterpriseEvent()

  const handleSubmitQuestion = () => {
    if (mCoachQuestion.trim() === '') {
      return
    }
    trackClickEvent(HOME_SECTION_TYPE.M_COACH, {
      action: 'ASK',
      question: mCoachQuestion
    })
    openMindset({ initialQuestion: mCoachQuestion, from: 'homepage' })
    setMCoachQuestion('') // Clear the input after submission
  }

  const handleOpenMindset = () => {
    trackClickEvent(HOME_SECTION_TYPE.M_COACH, {
      action: 'OPEN'
    })
    openMindset({ initialQuestion: '', from: 'homepage' })
  }

  if (hasBeenOpened) {
    return (
      <Box data-test='home-mcoach-rails'>
        <Card sx={{ borderRadius: '16px', backgroundColor: '#282E3E' }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
              <Typography sx={({ typography }) => ({ fontWeight: 'bold', color: '#FFFFFF', ...typography.body.l })}>
                What workplace challenge can we help you with?
              </Typography>
              <AutoAwesomeOutlined sx={{ color: '#4A5565' }} />
            </Box>
            <ActionButton
              label='Ask M:Coach'
              data-test='home-mcoach-rails-open-button'
              startIcon={<ChatAIWhite style={{ height: 20, width: 20 }} />}
              variant='primary'
              size='small'
              onClick={handleOpenMindset}
            />
          </CardContent>
        </Card>
      </Box>
    )
  }

  return (
    <Box data-test='home-mcoach-rails'>
      <Typography sx={({ typography }) => ({ fontWeight: 700, ...typography.body.l, mb: 2 })} data-test='home-mcoach-rails-title'>What workplace challenge can we help you with?</Typography>
      <Card sx={{ borderRadius: '16px', backgroundColor: '#282E3E' }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Typography sx={({ typography }) => ({ fontWeight: 'bold', color: '#FFFFFF', ...typography.body.l })}>
              Ask M:Coach
            </Typography>
            <AutoAwesomeOutlined sx={{ color: '#4A5565' }} />
          </Box>
          <TextField
            placeholder='Ask M:Coach to help with ”Difficult conversations”'
            value={mCoachQuestion}
            data-test='home-mcoach-rails-input'
            onChange={(e) => setMCoachQuestion(e.target.value)}
            sx={{ color: '#FFF' }}
            InputProps={{
              sx: {
                color: '#4A5565',
                '& .MuiInputBase-input': {
                  color: '#FFF'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#4A5565'
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#4A5565'
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#4A5565'
                }
              },
              endAdornment: (
                <Fab color='primary' size='small' sx={{ position: 'absolute', right: 8, bottom: 8 }} data-test='home-mcoach-rails-submit-button' onClick={handleSubmitQuestion}>
                  <ArrowUpward />
                </Fab>
              )
            }}
            multiline
            fullWidth
            minRows={3}
          />
        </CardContent>
      </Card>
    </Box>
  )
}
